export default __webpack_public_path__ + "static/media/change_middle_frame.a7bfadbb.svg";